import styled from 'styled-components'
import AppButton from 'Components/AppButton'
import Flex from 'Components/Flex'

import { BREAK_POINT_MD } from '@CSSVars/variables'

const DISCOVERY_BACKGROUND_COLOR = '#e3eff1'

export const _Container = styled.div`
  padding: ${({ isDiscoveryAreaCollapsed }) => (isDiscoveryAreaCollapsed ?
    '16px 20px 1px 20px' : '20px 24px 1px 24px')};
  overflow: hidden;
  background-color: ${DISCOVERY_BACKGROUND_COLOR};
  position: relative;
  min-height: ${({ isDiscoveryAreaCollapsed, isDiscoveryAreaOpen }) => (isDiscoveryAreaOpen ?
    '80vh' : isDiscoveryAreaCollapsed ? 'auto' : '127px')};

  &:hover {
    cursor: ${({ isDiscoveryAreaCollapsed }) => (isDiscoveryAreaCollapsed ?
    'pointer' : 'default')};
  }

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: none;
  }
`

export const _Title = styled.h2`
  font-size: 14px;
`


export const _ShowAllBtn = styled(AppButton)`
  font-size: 14px;
  font-weight: 600;
  padding: 2px 6px;
  &:hover {
    cursor: pointer;
  }
`

export const _AllAreaCollapsible = styled.div`
  margin-top: 12px;
`

export const _AreaChildrenListContainer = styled.div`
  margin-bottom: 24px;
`

export const _CollapseDiscoveryAreaBtn = styled(AppButton)`
  padding: 10px;
  position: absolute;
  right: 10px;
  top: 10px;
  transform: rotate(90deg);
  &:hover,
  &focus {
    cursor: pointer;
  }
`

export const _ShowDiscoveryAreaContainer = styled(Flex)`
  padding-bottom: 16px;
  &:hover {
    cursor: pointer;
  }
`
